// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"62":"94509885","721":"c590e7fd","907":"a41d0cec"}[chunkId] + ".chunk.js";
};